import AddActionItemModal from '../components/modals/AddActionItemModal/AddActionItemModal';
import AttachFilesModal from '../components/modals/AttachFilesModal/AttachFilesModal';
import ChangePasswordModal from '../components/modals/ChangePasswordModal/ChangePasswordModal';
import ChartsModal from '../components/modals/ChartsModal/ChartsModal';
import CompletionReportModal from '../components/modals/CompletionReportModal/CompletionReportModal';
import ContactSupportModal from '../components/modals/ContactSupportModal/ContactSupportModal';
import CostSavingTemplateModal from '../components/modals/CostSavingTemplateModal/CostSavingTemplateModal';
import CreateEditAssetTrackingModal from '../components/modals/CreateEditAssetTrackingModal/CreateEditAssetTrackingModal';
import CreateEditFacilityGroupModal from '../components/modals/CreateEditFacilityGroupModal/CreateEditFacilityGroupModal';
import CreateEditGpsTrackerModal from '../components/modals/CreateEditGpsTrackerModal/CreateEditGpsTrackerModal';
import CreateLocationModal from '../components/modals/CreateEditLocationModal/CreateLocationModal';
import EditLocationNameModal from '../components/modals/CreateEditLocationModal/EditLocationNameModal';
import MoveLocationModal from '../components/modals/CreateEditLocationModal/MoveLocationModal';
import EditCommentModal from '../components/modals/EditCommentModal/EditCommentModal';
import EditEquipmentDeactivationPeriodModal from '../components/modals/EditEquipmentDeactivationPeriodModal/EditEquipmentDeactivationPeriodModal';
import EditEquipmentNotesModal from '../components/modals/EditEquipmentNotesModal/EditEquipmentNotesModal';
import EditPhotosModal from '../components/modals/EditPhotosModal/EditPhotosModal';
import EditSensorGalleryModal from '../components/modals/EditSensorGalleryModal/EditSensorGalleryModal';
import EditSnoozeModal from '../components/modals/EditSnoozeModal/EditSnoozeModal';
import EquipmentDeactivateModal from '../components/modals/EquipmentDeactivateModal/EquipmentDeactivateModal';
import EquipmentEditModal from '../components/modals/EquipmentEditModal/EquipmentEditModal';
import InactiveEquipmentModal from '../components/modals/InactiveEquipmentModal/InactiveEquipmentModal';
import LightboxModal from '../components/modals/LightboxModal/LightboxModal';
import LocationDeleteModal from '../components/modals/LocationDeleteModal/LocationDeleteModal';
import LocationSelectModal from '../components/modals/LocationSelectModal/LocationSelectModal';
import LogOutConfirmModal from '../components/modals/LogOutConfirmModal/LogOutConfirmModal';
import ModalConfirm from '../components/modals/ModalConfirm/ModalConfirm';
import NewActionItemTypesModal from '../components/modals/NewActionItemTypesModal/NewActionItemTypesModal';
import OilReportModal from '../components/modals/OilReportModal/OilReportModal';
import PrivacyPolicyModal from '../components/modals/PrivacyPolicyModal/PrivacyPolicyModal';
import PrivacyPolicySettingsModal from '../components/modals/PrivacyPolicySettingsModal/PrivacyPolicySettingsModal';
import ProductGuidesModal from '../components/modals/ProductGuidesModal/ProductGuidesModal';
import ReplaceC1D1SensorConfirmModal from '../components/modals/ReplaceC1D1SensorConfirmModal/ReplaceC1D1SensorConfirmModal';
import ReplaceSensorMisConfirmModal from '../components/modals/ReplaceSensorMisConfirmModal/ReplaceSensorMisConfirmModal';
import ResetPasswordModal from '../components/modals/ResetPasswordModal/ResetPasswordModal';
import SensorReplaceModal from '../components/modals/SensorReplaceModal/SensorReplaceModal';
import SnoozeModal from '../components/modals/SnoozeModal/SnoozeModal';
import SwitchCustomerModal from '../components/modals/SwitchCustomerModal/SwitchCustomerModal';
import TemplateDeleteModal from '../components/modals/TemplateDeleteModal/TemplateDeleteModal';
import UserModal from '../components/modals/UserModal/UserModal';
import WarrantyModal from '../components/modals/WarrantyModal/WarrantyModal';

export const MODAL_NAMES = {
  editPhotosModal: 'editPhotosModal',
  lightboxModal: 'lightboxModal',
  resetPasswordModal: 'resetPasswordModal',
  locationSelectModal: 'locationSelectModal',
  snoozeModal: 'snoozeModal',
  equipmentEditModal: 'equipmentEditModal',
  createLocationModal: 'createLocationModal',
  attachFilesModal: 'attachFilesModal',
  completionReportModal: 'completionReportModal',
  modalConfirm: 'modalConfirm',
  inactiveEquipmentModal: 'inactiveEquipmentModal',
  equipmentDeactivateModal: 'equipmentDeactivateModal',
  sensorReplaceModal: 'sensorReplaceModal',
  replaceSensorMisConfirmModal: 'replaceSensorMisConfirmModal',
  replaceC1D1SensorConfirmModal: 'replaceC1D1SensorConfirmModal',
  editLocationModal: 'editLocationModal',
  privacyPolicyModal: 'privacyPolicyModal',
  privacyPolicySettingsModal: 'privacyPolicySettingsModal',
  costSavingTemplateModal: 'costSavingTemplateModal',
  templateDeleteModal: 'templateDeleteModal',
  chartsModal: 'chartsModal',
  addActionItemModal: 'addActionItemModal',
  logoutConfirmModal: 'logoutConfirmModal',
  switchCustomerModal: 'switchCustomerModal',
  locationDeleteModal: 'locationDeleteModal',
  userModal: 'userModal',
  locationMoveModal: 'locationMoveModal',
  changePasswordModal: 'changePasswordModal',
  newActionItemTypesModal: 'newActionItemTypesModal',
  createEditGpsTrackerModal: 'createEditGpsTrackerModal',
  createEditAssetTrackingModal: 'createEditAssetTrackingModal',
  oilReportModal: 'oilReportModal',
  editEquipmentNotesModal: 'editEquipmentNotesModal',
  editCommentModal: 'editCommentModal',
  editSnoozeModal: 'editSnoozeModal',
  productGuidesModal: 'productGuidesModal',
  warrantyModal: 'warrantyModal',
  editEquipmentDeactivationPeriodModal: 'editEquipmentDeactivationPeriodModal',
  contactSupportModal: 'contactSupportModal',
  editSensorGalleryModal: 'editSensorGalleryModal',
  createEditFacilityGroupModal: 'createEditFacilityGroupModal',
};

export const MODAL_RENDERERS = {
  [MODAL_NAMES.editPhotosModal]: EditPhotosModal,
  [MODAL_NAMES.lightboxModal]: LightboxModal,
  [MODAL_NAMES.resetPasswordModal]: ResetPasswordModal,
  [MODAL_NAMES.locationSelectModal]: LocationSelectModal,
  [MODAL_NAMES.snoozeModal]: SnoozeModal,
  [MODAL_NAMES.equipmentEditModal]: EquipmentEditModal,
  [MODAL_NAMES.createLocationModal]: CreateLocationModal,
  [MODAL_NAMES.attachFilesModal]: AttachFilesModal,
  [MODAL_NAMES.completionReportModal]: CompletionReportModal,
  [MODAL_NAMES.modalConfirm]: ModalConfirm,
  [MODAL_NAMES.inactiveEquipmentModal]: InactiveEquipmentModal,
  [MODAL_NAMES.equipmentDeactivateModal]: EquipmentDeactivateModal,
  [MODAL_NAMES.sensorReplaceModal]: SensorReplaceModal,
  [MODAL_NAMES.replaceSensorMisConfirmModal]: ReplaceSensorMisConfirmModal,
  [MODAL_NAMES.replaceC1D1SensorConfirmModal]: ReplaceC1D1SensorConfirmModal,
  [MODAL_NAMES.editLocationModal]: EditLocationNameModal,
  [MODAL_NAMES.privacyPolicyModal]: PrivacyPolicyModal,
  [MODAL_NAMES.privacyPolicySettingsModal]: PrivacyPolicySettingsModal,
  [MODAL_NAMES.costSavingTemplateModal]: CostSavingTemplateModal,
  [MODAL_NAMES.templateDeleteModal]: TemplateDeleteModal,
  [MODAL_NAMES.chartsModal]: ChartsModal,
  [MODAL_NAMES.addActionItemModal]: AddActionItemModal,
  [MODAL_NAMES.logoutConfirmModal]: LogOutConfirmModal,
  [MODAL_NAMES.switchCustomerModal]: SwitchCustomerModal,
  [MODAL_NAMES.locationDeleteModal]: LocationDeleteModal,
  [MODAL_NAMES.userModal]: UserModal,
  [MODAL_NAMES.locationMoveModal]: MoveLocationModal,
  [MODAL_NAMES.changePasswordModal]: ChangePasswordModal,
  [MODAL_NAMES.newActionItemTypesModal]: NewActionItemTypesModal,
  [MODAL_NAMES.createEditGpsTrackerModal]: CreateEditGpsTrackerModal,
  [MODAL_NAMES.createEditAssetTrackingModal]: CreateEditAssetTrackingModal,
  [MODAL_NAMES.oilReportModal]: OilReportModal,
  [MODAL_NAMES.editEquipmentNotesModal]: EditEquipmentNotesModal,
  [MODAL_NAMES.editCommentModal]: EditCommentModal,
  [MODAL_NAMES.editSnoozeModal]: EditSnoozeModal,
  [MODAL_NAMES.productGuidesModal]: ProductGuidesModal,
  [MODAL_NAMES.warrantyModal]: WarrantyModal,
  [MODAL_NAMES.editEquipmentDeactivationPeriodModal]: EditEquipmentDeactivationPeriodModal,
  [MODAL_NAMES.contactSupportModal]: ContactSupportModal,
  [MODAL_NAMES.editSensorGalleryModal]: EditSensorGalleryModal,
  [MODAL_NAMES.createEditFacilityGroupModal]: CreateEditFacilityGroupModal,
};
